import {guestActions} from '../actions';

export default function guest(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        // case guestActions.SET_GUEST_MODE:
        //     return setGuestMode(newState, action);
        // case guestActions.TOGGLE_GUEST_MODE:
        //     return setGuestMode(newState, action);
        default:
            return newState;
    }
}

function setGuestMode(newState, action) {
    delete action.type;
    newState = Object.assign(newState, {...action});
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/guest.js